import { render, staticRenderFns } from "./record-detail.vue?vue&type=template&id=753e4e11&scoped=true&"
import script from "./record-detail.vue?vue&type=script&lang=js&"
export * from "./record-detail.vue?vue&type=script&lang=js&"
import style0 from "./record-detail.vue?vue&type=style&index=0&id=753e4e11&lang=less&scoped=true&"
import style1 from "./record-detail.vue?vue&type=style&index=1&id=753e4e11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753e4e11",
  null
  
)

export default component.exports